import { Github, Linkedin, Mail, Terminal } from "lucide-react";

const SOCIALS = [
  {
    href: "https://github.com/khadim-hussain-j",
    Icon: Github,
    label: "GitHub",
  },
  {
    href: "https://linkedin.com/in/khadim-hussainj",
    Icon: Linkedin,
    label: "LinkedIn",
  },
  { href: "mailto:khadimhussainj14@gmail.com", Icon: Mail, label: "Email" },
];

export default function Footer() {
  const year = new Date().getFullYear();

  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="border-t border-[#1e293b] bg-[#050505] py-10 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-6">
        {/* Logo */}
        <button
          onClick={scrollTop}
          aria-label="Back to top"
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-[#1e293b] bg-[#111111] hover:border-indigo-500/50 transition-colors duration-200"
        >
          <Terminal size={13} className="text-indigo-400" />
          <span className="font-mono text-sm font-semibold text-indigo-400">
            kh
          </span>
          <span className="font-mono text-xs text-[#94a3b8] animate-[blink_1s_step-end_infinite]">
            _
          </span>
        </button>

        {/* Copyright */}
        <p className="font-mono text-xs text-[#94a3b8] text-center">
          © {year} Khadim Hussain
          {/* <span className="text-indigo-400">
            Built with Vite + React + Tailwind
          </span> */}
        </p>

        {/* Socials */}
        <div className="flex items-center gap-2">
          {SOCIALS.map(({ href, Icon, label }) => (
            <a
              key={label}
              href={href}
              target={href.startsWith("mailto") ? undefined : "_blank"}
              rel="noopener noreferrer"
              aria-label={label}
              className="p-2 rounded-lg border border-[#1e293b] bg-[#111111] hover:border-indigo-500/50 text-[#94a3b8] hover:text-indigo-400 transition-all duration-200"
            >
              <Icon size={14} />
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
